import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { CardSection } from 'legacyComponents/layout/cardSection';
import { CollectionCard } from 'legacyComponents/cards/types/collection';

import { modalStore } from 'apps/modals/app';
import { MainWrapper } from 'legacyComponents/styled/lib';

import { CollectionForm } from 'apps/collection/collectionForm/index';

import { conf } from 'apps/profile/config.yaml';

const ProfileCollections = props => {
  const { appManager, t } = props;
  const { profile, collectionsConn } = appManager;
  const collections = collectionsConn.arrayApp;

  const { canUpdate, fullName } = profile;
  const {
    inSpace: { whichTypes },
  } = profile;
  const displayName = fullName.split(' ')[0];

  return (
    <MainWrapper>
      <CardSection
        title={conf.sections[2]}
        tooltip={t('Create new collection')}
        updateHeader={true}
        index={3}
        createHandler={
          whichTypes.includes('Collection')
            ? () => modalStore.SetModalComponent(CollectionForm)
            : () => ''
        }
        owner={canUpdate}
        ownerName={displayName}
        cardApp={collections}
        CardComponent={CollectionCard}
        noDataCardType='collection'
        gridColumns={3}
        canShowNoDataCard
      />
    </MainWrapper>
  );
};

ProfileCollections.propTypes = {
  routeName: PropTypes.string,
  params: PropTypes.object,
  t: PropTypes.func,
  appManager: PropTypes.object,
};

export default withNamespaces()(observer(ProfileCollections));
